<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div class="d-flex flex-column gap-8">
  <div>
    <div id="header-container">
      <h3 id="header-text">Save Global Vehicle Forecast Template</h3>
    </div>
    <div class="drag-and-drop-container">
      <h4>
        <span class="template-dropzone-label">Please Select File to select worksheets from. </span> (Required
        Format: .xls or .xlsx)
      </h4>
    </div>
    <div (files)="upload($event)" appDrag class="dropzone">
      <div class="text-wrapper">
        <div class="centered">Drag and Drop Files Here</div>
        <p class="centered">or</p>
        <div>
          <app-upload-button (eventEmitter)="upload($event)" [apiUrl]="excelService.excelSheetUrl"
                             class="upload centered app-upload-button">
          </app-upload-button>
        </div>
      </div>
    </div>
  </div>

</div>
